<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="closeModal()" />
</div>

<ion-content class="slett-bruker-grid" *ngIf="userInfo">
  <ion-grid class="ion-margin">
    <ion-row>
      <ion-col>
        <ion-title class="smaller">
          <h1>Slette bruker?</h1>
        </ion-title>
      </ion-col>
    </ion-row>
    <ion-row class="ion-padding-top">
      <ion-col>
        <p>
          Vil du slette din bruker på Min Side tilknyttet
          <b>{{ userInfo.email }}</b
          >?
          <br />
          Denne handlingen kan ikke reverseres.
        </p>
        <p>
          Du vil miste tilgangen til Min Side, og dermed også oversikten over
          ditt forbruk, dine avtaler, og dine regninger. Du må lage deg en ny
          bruker om du skulle ønske å benytte deg av Min Side på et senere
          tidspunkt. Om noen har delt tilgang til sitt forbruk med deg, må dette
          deles på nytt.
        </p>
        <p>
          Å slette din bruker på Min Side vil <b>ikke</b> avslutte ditt
          kundeforhold hos Ishavskraft. Om du ønsker å avslutte ditt
          kundeforhold hos oss, må du ta kontakt med kundeservice på
          <a href="mailto:kunde@ishavskraft.no">kunde&#64;ishavskraft.no</a>
          eller på telefon <a href="tel:77612000">776 12 000</a>.
        </p>
      </ion-col>
    </ion-row>
    <ion-row class="ion-padding-top">
      <ion-col class="error-container">
        <p *ngIf="error" class="error">{{ error }}</p>
      </ion-col>
    </ion-row>
    <ion-row class="ion-padding-top">
      <ion-col>
        <ion-button
          class="dark"
          (click)="deleteKCUser()"
          (disabled)="(deleteInProgress)"
        >
          Ja, slett bruker på Min Side
          <ion-icon name="trash-outline"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
